import CloseIcon from "@/assets/images/icons/close.svg?inline";
import BackIcon from "@/assets/images/icons/back.svg?inline";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

import QuizField from "@/views/Home/components/QuizField";

import RegistrationOptions from "@/views/auth/QuestionaryAuth/RegistrationOptions";
import SignUpForm from "@/views/auth/components/SignUpForm";

import ConfirmPhoneSlide from "@/views/auth/ConfirmationPhone";
import ConfirmEmailSlide from "@/views/auth/ConfirmationEmail";
import PersonalizeSlide from "@/views/auth/Personalize";
// import LoaderProgress from "@/components/LoaderProgress";

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import {
  PROPERTY_TYPES,
  QUESTIONS,
  QUESTION_BACKGROUNDS
} from "../gql/HomeQueries";

export default {
  name: "questionary",

  data() {
    return {
      sliderBackgrounds: [],
      firstSlideBackgrounds: [],
      backgroundSwiper: null,
      propertyTypes: [],
      selectedPropertyType: {},

      questions: [],
      questionsTest: [],

      isInitQuiz: false,
      skipQuery: true,
      questionsSwiper: null,
      quizSwiper: null,
      swiperOption: {
        height: 667,
        speed: 800,
        simulateTouch: false,
        allowTouchMove: false,
        init: false
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev"
        // }
      },

      activeQuestionId: false,

      backgroundSwiperOption: {
        slidesPerView: 1,
        height: 667,
        speed: 800,
        loop: true,
        effect: "fade",
        init: false
      },

      searchFilters: [],

      needRegistration: false,
      isManualRegistration: false,
      isEmailRegistration: false
      // isNeedShowFinishLoader: false
    };
  },

  apollo: {
    sliderBackgrounds: {
      query: QUESTION_BACKGROUNDS
    },

    propertyTypes: {
      query: PROPERTY_TYPES,
      result: function({ data }) {
        if (data && data.propertyTypes && this.$route.name === 'properties')
          this.propertyTypes = data.propertyTypes.filter(info => !info.name.includes("Skip", "skip"));
      }
    },

    questions: {
      query: QUESTIONS,
      variables() {
        return {
          propertyTypeId: +this.selectedPropertyType.id
        };
      },
      skip() {
        return this.skipQuery;
      },
      result: function({ data }) {
        this.skipQuery = true;

        if (data) {
          this.loading = false;
          this.isInitQuiz = true;

          this.$refs.backgroundSwiper.swiper.update();
        }

        this.backgroundSwiper.slideNext();
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    this.quizSwiper.destroy;
    this.quizSwiper.destroy(false, false);

    this.backgroundSwiper.destroy;
    this.backgroundSwiper.destroy(false, false);

    this.$root.$emit("setStartQuiz", false);
  },

  computed: {
    showBackButton() {
      if (this.quizSwiper) {
        return this.quizSwiper.activeIndex > 0;
      }
    },

    totalSlides() {
      return this.questions.length;
    },

    commonSliderBackgrounds() {
      return this.isInitQuiz
        ? this.sliderBackgrounds
        : this.sliderBackgrounds.splice(0, 1);
    }
  },

  watch: {
    questions: function() {
      if (this.questions.length == 0) {
        this.needRegistration = false;
        this.isManualRegistration = false;
      }

      // this.questionsTest = this.questions.slice(13, 15);
      this.quizSwiper.init();
    },

    sliderBackgrounds: function() {
      this.$nextTick(() => {
        this.backgroundSwiper.init();
      });
    },

    isInitQuiz: function(newInit) {
      if (newInit && this.quizSwiper && !this.quizSwiper.destroyed) {
        this.$nextTick(() => {
          // this.$store.commit("setStartQuiz", true);
          this.$root.$emit("setStartQuiz", true);
          this.quizSwiper.slideNext();
        });
      }
    }
  },

  mounted: function() {
    let self = this;
    this.$root.$on("reloadMainPage", function() {
      self.destroyQuestions();
    });

    this.quizSwiper = this.$refs.mySwiper.swiper;
    this.backgroundSwiper = this.$refs.backgroundSwiper.swiper;

    window.addEventListener("resize", this.updateQuizSwiper);
  },

  methods: {
    updateQuizSwiper() {
      this.quizSwiper.update();
      this.backgroundSwiper.update();
    },

    startQuiz(type) {
      this.selectedPropertyType = type;

      if (!this.questions.length && this.selectedPropertyType.name.includes("Skip", "skip")) {
        return this.$router.push({name: 'properties'})
      }

      this.$store.commit("setPropertyTypeId", type.id);

      if (type.forSeller) {
        this.quizSwiper.init();
        this.activateRegistration();
      } else {
        for (let filter in type.filters) {
          this.searchFilters.push({
            tagId: type.filters[filter].tagId,
            value: type.filters[filter].value
          });
        }

        this.skipQuery = false;
      }
    },

    nextQuestion(data) {
      if (data.filter.tagId != null) {
        this.addFilter(data);
      }

      if (this.quizSwiper.isEnd) {
        // Push to STORE

        this.$store.commit("setFilters", this.searchFilters);
        // this.$router.push({ name: "sign_up" });

        // Need registration
        this.activateRegistration();
      } else {
        this.quizSwiper.slideNext();

        this.$refs.backgroundSwiper.swiper.slideNext();
      }
    },

    addFilter(data) {
      let currentIndex = null;

      currentIndex = this.searchFilters.findIndex(
        f => f.tagId == data.filter.tagId
      );

      if (currentIndex >= 0) {
        this.$set(this.searchFilters, currentIndex, data.filter);
      } else {
        this.searchFilters.push(data.filter);
      }
    },

    prevQuestions() {
      if (this.quizSwiper.activeIndex == 1) {
        this.destroyQuestions();
      }

      if (this.quizSwiper.activeIndex > 0) {
        this.quizSwiper.slidePrev();
        this.backgroundSwiper.slideNext();
      }
    },

    destroyQuestions() {
      let self = this;

      setTimeout(function() {
        self.questions = [];
        self.isInitQuiz = false;
        self.selectedPropertyType = {};
        self.$root.$emit("setStartQuiz", false);

        if (localStorage.getItem("searchParams")) {
          localStorage.removeItem("searchParams");
        }
      }, 200);
    },

    nextSlideEnd() {
      if (this.questions[this.quizSwiper.activeIndex - 1] !== undefined) {
        let activeQuestionType = this.questions[this.quizSwiper.activeIndex - 1]
          .questionType;

        if (
          activeQuestionType == "text_loader" ||
          activeQuestionType == "image_loader"
        ) {
          this.activeQuestionId = activeQuestionType;
        } else {
          this.activeQuestionId = false;
        }
      }
    },

    activateRegistration() {
      this.needRegistration = true;

      this.nextTickSlide();
    },

    handleManualRegistration() {
      this.isManualRegistration = true;

      this.nextTickSlide();
    },

    // handleNextSlide() {
    //   this.nextTickSlide();
    // },

    nextTickSlide(type = "") {
      this.isEmailRegistration = type == "email" ? true : false;

      this.$nextTick(() => {
        this.quizSwiper.slideNext();
        this.$refs.backgroundSwiper.swiper.slideNext();
      });
    }

    // handleShowFinishLoader() {
    // this.isNeedShowFinishLoader = true;
    // }
  },

  components: {
    CloseIcon,
    BackIcon,
    LoadingIcon,
    swiper,
    swiperSlide,
    QuizField,

    RegistrationOptions,
    SignUpForm,
    ConfirmPhoneSlide,
    ConfirmEmailSlide,
    PersonalizeSlide
    // LoaderProgress
  }
};
